/**
 * KEYE-API
 * API for KEYE portal
 *
 * OpenAPI spec version: 2022-12-19
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface GetDetectionRequest { 
    devices?: Array<string>;
    categories?: Array<string>;
    start_time?: number;
    end_time?: number;
    lon_min?: number;
    lat_min?: number;
    lon_max?: number;
    lat_max?: number;
    score_threshold?: number;
    status?: Array<string>;
    page_number?:number;
    entries_page?:number;
    min_width?:number;
    max_width?:number;
}
